import './App.css';
import { createTheme, ThemeProvider } from '@mui/material';
import { appRouter } from './routes';
import { RouterProvider } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { NotificationProvider } from './context/NotificationContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useEffect } from 'react';
import { fetchWishlist } from './redux/wishlistSlice';
import { fetchCart } from './redux/cartSlice';
import { fetchAllCategories } from './redux/categoriesSlice';
import ScrollToTop from './components/common/ScrollToTop';

// !-----------------Theme-----------------!
const theme = createTheme({
  palette: {
    badgeColor: { main: "#ED1C24" },
    primary: {
      main: "#000000", 
      red: "#d9534f",
      bg: "#444444",
      gray: "#808080",
      green: "#008000",
      blue: "#3B5998",
      med_blue: "#0077B5",
      light_blue: "#1DA1F2",
      light_gray: "#EAEAEA",
      lighter_gray: "#ccc"
    },
    secondary: {
      main: "#C31E40",
      dark: "#333333",
      light: "#fff5f5",
      lighter: "#f9f9f9"
    },
    seprator_color:{
      main:"#3F3F3F33"
    },
    "heading_color": {
      main:"#474747"
    },
    tertiary:{
      main:"#FFFFFF",
      secondary: "#FF431B",
      bg_address: "#ffffff1a",
      shadow_address: "#0000001a",
      shadow_phone: "#0080001a",
      shadow_error: "#ff00001a"
    },
    address:{
      edit: "#4A90E2",
      edit_dark: "#63B3ED",
      password: "#B52441",
      password_dark: "#ED1C24",
      address_book: "#68D391",
      address_book_dark: "#9AE6B4",
      wishlist: "#F6AD55",
      wishlist_dark: "#FBD38D",
      history: "#805AD5",
      history_dark: "#B794F4"
    },
    image: {
      image_light: "#3f51b5",
      image_dark: "#2196f3"
    },
    notification:{
      blue_light: "#3B82F6",
      blue_dark: "#2563EB",
      orange_light: "#F59E0B",
      orange_dark: "#D97706",
      green_light: "#10B981",
      green_dark: "#059669",
      red_light: "#EF4444",
      red_dark: "#DC2626"
    }
  },
  typography: {
    fontFamily: '"PT Sans", sans-serif',
  },
  paragraph: {
    fontFamily: '"PT Sans", sans-serif',
  },
  heading: {
    fontFamily: '"PT Sans", sans-serif',
  },
  breakpoints: {
    values: {
      xs: 0,
      // xss:200,
      xsPlus: 400,
      br500: 500,
      sm: 600,
      xsm: 700,
      md: 900,
      xmd: 1000,
      mdPlus: 1100,
      lg: 1200,
      xlg: 1400,
      xl: 1536,
      xlPlus: 2000,

    },
  },
});
function App() {
  const dispatch = useDispatch();
  const {user,token,_} = useSelector(state=>state.auth);

  // !-----------------Router-----------------!
  const getRouter = () => {
    return appRouter;
  }
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 30000,
      },
    },
  });
  // const checkCache = () => {
  //   console.log(queryClient.getQueryData(['homeFeed']));
  // };

  const fetchWishlistData = async () => {
    try {
      await dispatch(fetchWishlist({ userId: user.id,rowsPerPage: '10000',page:'all' }));
    } catch (error) {
      console.error(error);
    }
  }
  const fetchCartData = async () => {
    try {
      await dispatch(fetchCart());
    } catch (error) {
      console.error(error);
    }
  }
const fetchCategories=async()=>{
  try {
    await dispatch(fetchAllCategories())
  } catch (error) {
    console.error(error);
  }
}
 useEffect(() => {
  if (token) {
    fetchCartData();
    fetchCategories();
    fetchWishlistData();
  }
}, [token, dispatch]);

  return (

  
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <NotificationProvider>
          <RouterProvider router={getRouter()} >
          <ScrollToTop />

          </RouterProvider>
        </NotificationProvider>
      </ThemeProvider>
    </QueryClientProvider>
 
   
  );
}

export default App;
